import { atom } from 'jotai'

import { type ShipmentOrdersListExEntity } from '@/libs/api'

/**
 * 配車板の配送依頼の編集で表示する配送依頼情報
 */
export const notDispatchedShipmentOrderUpdateAtom =
  atom<ShipmentOrdersListExEntity | null>(null)

notDispatchedShipmentOrderUpdateAtom.debugLabel =
  'notDispatchedShipmentOrderUpdateAtom'
